import React, { Component } from "react";
import Template from "./template";
import { Modal, Button, Nav } from "react-bootstrap";
import { isValidArray } from "../../../../helper";

// loader
import { LoaderPage } from "../../../../component/Loader";

// context
import { SendSmsEmailConext } from "../../provider";

// helpers
import { get } from "lodash";

class EmailComponent extends Component {
  static contextType = SendSmsEmailConext;

  state = {
    displayTab: 0,
    userNotificationType: null
  };

  onTabsClick = event => {
    const {
      dataset: { tabsIndex, tabsType }
    } = event.target;

    this.setState(
      {
        isLoading: true
      },
      () => {
        this.setState({
          isLoading: false,
          displayTab: +tabsIndex,
          userNotificationType: tabsType
        });
      }
    );
  };

  render() {
    const { onTabsClick } = this;
    const { displayTab, isLoading, userNotificationType } = this.state;
    const { meetingId } = this.props;
    const {
      stakeHoldersData: templateInfo = [],
      onCloseModal = () => {}
    } = this.context;
    const notificationType = userNotificationType
      ? userNotificationType
      : isValidArray(templateInfo)
      ? get(templateInfo[0], "userNotificationType.name")
      : null;

    // active template
    const currentTemplate = isValidArray(templateInfo)
      ? templateInfo[displayTab]
      : null;

    return (
      <>
        <Modal
          show={true}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="send_notification_modal"
          onHide={onCloseModal}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Nav>
              {isValidArray(templateInfo) ? (
                templateInfo.map((template, index) =>
                  get(template, "userNotificationType") ? (
                    <Button
                      data-tabs-index={index}
                      data-tabs-type={get(
                        template,
                        "userNotificationType.name"
                      )}
                      variant={
                        index == displayTab ? "info" : "outline-secondary"
                      }
                      onClick={onTabsClick}
                    >
                      {get(template, "userNotificationType.displayName")}
                    </Button>
                  ) : null
                )
              ) : (
                <React.Fragment />
              )}
            </Nav>

            {isLoading ? (
              <LoaderPage loading={isLoading} />
            ) : currentTemplate ? (
              <Template
                meetingId={meetingId}
                tabIndex={displayTab}
                templateInfo={currentTemplate}
                userNotificationType={notificationType}
              />
            ) : (
              <React.Fragment />
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export { EmailComponent };
